import { rootApi } from "../../api/rootApi";

export const batchApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllSBHistoryForBorosil: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/sb-history`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchAllUserPointSummaryBorosil: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/point-summary?${params.queryParams}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          // body: params.body,
        };
      },
    }),

    fetchMonthWisePoints: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/monthwise-points?${params.queryParams}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          // body: params.body,
        };
      },
    }),


    fetchBorosilOrderList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/panel/order-list`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchBorosilOrderListCount: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/panel/order-list/count`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchBorosilUserPointHistory: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/panel/point-history`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    sendBorosilBulkSms: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/bulk-sms`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),


    getAccountsReport: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/borosil/accounts-report`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    getFyAccountsReport: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/borosil/fy-report?year=${params.year}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),


    getDetailedReport: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/borosil/detailed-report`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    getAllParentChildMapping: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/borosil/all-parent-child-codes`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),


    getFinancialWalletsReport: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/panel/fy-wallets-list`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    exportBorosilOrderList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/panel/order-list/export`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    updateSBHistoryStatus: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/sb-history/update-status`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchAllSBHistoryForBorosilMutation,
  useFetchAllUserPointSummaryBorosilMutation,
  useFetchMonthWisePointsMutation,
  useFetchBorosilOrderListMutation,
  useFetchBorosilOrderListCountMutation,
  useFetchBorosilUserPointHistoryMutation,
  useSendBorosilBulkSmsMutation,
  useGetAccountsReportMutation,
  useGetFyAccountsReportMutation,
  useGetDetailedReportMutation,
  useGetAllParentChildMappingMutation,
  useGetFinancialWalletsReportMutation,
  useExportBorosilOrderListMutation,
  useUpdateSBHistoryStatusMutation
} = batchApi;
